import { api } from './client';

export type AppConfigPayload = {
  displayName: string;
  product: { name: string; tagline: string };
  company: {
    id: string;
    name: string;
    address: string;
    phone: string;
    email: string;
  };
  companies: unknown[];
  defaultCompanyEntityId: string | null;
};

export async function fetchAppConfig() {
  return api<AppConfigPayload>('/app-config');
}
